import React, { useState, useEffect } from "react";
import { JobService } from "../../../services/JobService";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Table,
  CardHeader,
  CardFooter,
} from "reactstrap";

import TreeView from "react-treeview";

import $ from "jquery";

import { toast } from "react-toastify";

const CertificationSearch = (props) => {
  const {parentCallback,deletedList}=props;
  const [modalCertification, setModalCertification] = useState(false);
  const [categories, setCategories] = useState([]);
  const [filteredCertifications, setFilteredCertifications] = useState([]);
  const [scategories, setSCategories] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const [treeview, setTreeview] = useState(true);
  const [languageshow, setlanguageShow] = useState(true);
  const [selectedCertificationIds, setSelectedCertificationIds] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [jobSkillLevels, setJobSkillLevels] = useState([]);
  const [certificationId, setCertificationId] = useState("");
  const [newList, setNewList] = useState([]);
  const [searchCertification,setSearchCertification]=useState([])
 

  const onAddCertification = () => {
    setModalCertification(true);
   
  };

  useEffect(()=>{
    setNewList(deletedList)
 },[deletedList])

  useEffect(() => {
    getTotalCertificationsList();
  }, []);


  const getTotalCertificationsList = () => {
    JobService.getcertificationService().then((response) => {
     
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var skillDetails = response.data;
          if (skillDetails != null) {
            const indlist = skillDetails.indlist;

            if (indlist.length > 0) {
              indlist.map((industrydetails, index) => {
                industrydetails.categories.length > 0 &&
                  industrydetails.categories.map((category, index) => {
                    category.skills.length > 0 &&
                      category.skills.map((skill, indexval) => {
                        category.skills[indexval].skillLevel = "";
                      });
                  });
              });
              setCategories(indlist);
              setFilteredCertifications(indlist);
              setSearchCertification(indlist)
            } else {
              setCategories([]);
              setFilteredCertifications([]);
              setSearchCertification([])
            }
          }
        }
      } catch (err) {}
    });
  };

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    if (searchValue !== "" && searchValue.length >= 3) {
      setTreeview(false);
      JobService.searchCertifications(searchValue).then((response) => {
        try {
          if (response.data != null) {
            setFilteredCertifications(response.data.indlist);
          }
        } catch (err) {
          console.log(err);
        }
      });
    } else {
      setTreeview(true);
      setFilteredCertifications(categories);
    }
  };

  const addCertificationDetails = () => {
    setFilteredCertifications(searchCertification);
    parentCallback(newList);
    setModalCertification(false);
  };

  const onCancleCetificationSearch=()=>{
    setModalCertification(false);
    setFilteredCertifications(searchCertification);
  }
  const handleCheck = (event, Skills) => {
 
    if (event.target.checked) {
     if (newList.length>0){
        if ([...newList].includes(Skills)===false){
          setNewList([...newList,Skills])
        }
     }
     else{
      setNewList([...newList,Skills])
     }
        
    } 
    else if (event.target.checked===false) {
      
      setNewList(newList.filter(item=>item.id!==Skills.id))
    }
   
  };

 
  return (
    <>
      <Button
        className="btn-sm mt-1 t-button-skill-edu btn "
        type="submit"
        color="primary"
        outline
        onClick={onAddCertification}
      >
        + Certificates
      </Button>
      
      <Modal
        scrollable={true}
        isOpen={modalCertification}
        toggle={() => setModalCertification(!modalCertification)}
      >
        <ModalHeader className="mdl_header">
          <div>
            <strong>Select Certificates</strong>
          </div>
        </ModalHeader>
        <ModalBody className="labelSize">
          <div className="col-lg-12 p-0">
            <Input
              type="text"
              icon="search"
              placeholder="Search for skills"
              onChange={(e) => searchItems(e.target.value)}
            />
          </div>
          {languageshow &&
            filteredCertifications.length > 0 &&
            filteredCertifications.map((industrydetails, index) => {
              return (
                <TreeView
                  key={index}
                  nodeLabel={industrydetails.industry}
                  defaultCollapsed={false}
                  className="treeViewIconSize mb-2"
                >
                  <div className="col">
                    {industrydetails.categories.length > 0 &&
                      industrydetails.categories.map((category, index) => {
                        return (
                          <div key={index}>
                            {category.name == null || category.name == " " ? (
                              <div>
                                {category.skills.length > 0 &&
                                  category.skills.map((skill, index) => {
                                    return (
                                      <div  key={index}>
                                      <div className="col-12">
                                          <div className="row">
                                            <div className="col-sm-6">
                                              <input
                                                id="certificationId"
                                                type="checkbox"
                                                className="input_skill"
                                                
                                                onChange={(e) =>
                                                  handleCheck(
                                                    e,
                                                    skill
                                                    
                                                  )
                                                }
                                              />
                                              <label
                                                id="certificationName"
                                                className="terms"
                                              >
                                                {" "}
                                                {skill.name}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            ) : (
                              <div>
                                <TreeView
                                  nodeLabel={category.name}
                                  defaultCollapsed={false}
                                  className="treeViewIconSize mb-2"
                                >
                                  <div>
                                    {category.skills.length > 0 &&
                                      category.skills.map((skill, index) => {
                                        
                                        return (
                                          <div  key={index}>
                                          <div className="col-12">
                                              <div className="row">
                                                <div className="col-sm-12">
                                                  <label className="terms">
                                                    <input
                                                      id="certification"
                                                      type="checkbox"
                                                      className="input_skill"
                                                      
                                                      onChange={(e) =>
                                                        handleCheck(
                                                          e,
                                                          skill
                                                         
                                                        )
                                                      }
                                                    />{" "}
                                                    {skill.name}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </TreeView>
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </TreeView>
              );
            })}
          {filteredCertifications.length == 0 && (
            <div className="t-nodata mt-4">
              <strong>Certification not found</strong>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="p-4">
          <Button
            color="primary"
            size="sm"
            outline
            onClick={addCertificationDetails}
          >
            Save
          </Button>{" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={onCancleCetificationSearch}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

       
    </>
  );
};
export default CertificationSearch;